import React, { Context, createContext } from 'react';
import { useCreditRedemptionModal } from 'utils/hooks/useCreditRedemptionModal';
import CreditRedemptionModal from '../../../components/MembershipPDP/CreditRedemptionModal';
import { CreditRedemptionModalContextType } from './types';

export const CreditRedemptionModalContext: Context<CreditRedemptionModalContextType> =
  createContext<CreditRedemptionModalContextType>({
    _openCreditRedemptionModal: false,
    openCreditRedemptionModal: () => {},
    closeCreditRedemptionModal: () => {},
    setVariantId: () => {},
    processCreditRedemptionModalOrder: () => {},
  });

export const CreditRedemptionModalProvider: React.FC = ({ children }) => {
  const value = useCreditRedemptionModal();

  return (
    <CreditRedemptionModalContext.Provider value={value}>
      {children}
      <CreditRedemptionModal />
    </CreditRedemptionModalContext.Provider>
  );
};
